import React from 'react';

const Reviews = () => {
    return (
        <div className="container mt-5 mb-5">
            <h5 className="text-center text-success">REVIEWS</h5>
            <div class="row row-cols-1 row-cols-md-2 g-4">
                <div class="col">
                    <div class="card">
                        <div class="card-body">
                            <h5 class="card-title">David Warner</h5>
                            <p class="card-text">The best drones have brought responsive flying experiences to the masses, and their camera and streaming capabilities have made it cheaper and easier for filmmakers to take to the skies for a smooth, 4K aerial shot. We dive into the entry-level and enthusiast options from popular drone makers, like DJI, to see what each new drone brings to the market.</p>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="card">
                        <div class="card-body">
                            <h5 class="card-title">Mathew Wade</h5>
                            <p class="card-text">The best drones have brought responsive flying experiences to the masses, and their camera and streaming capabilities have made it cheaper and easier for filmmakers to take to the skies for a smooth, 4K aerial shot. We dive into the entry-level and enthusiast options from popular drone makers, like DJI, to see what each new drone brings to the market.</p>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="card">
                        <div class="card-body">
                            <h5 class="card-title">Shane Watson</h5>
                            <p class="card-text">The best drones have brought responsive flying experiences to the masses, and their camera and streaming capabilities have made it cheaper and easier for filmmakers to take to the skies for a smooth, 4K aerial shot. We dive into the entry-level and enthusiast options from popular drone makers, like DJI, to see what each new drone brings to the market.</p>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="card">
                        <div class="card-body">
                            <h5 class="card-title">Mitchel Mark</h5>
                            <p class="card-text">The best drones have brought responsive flying experiences to the masses, and their camera and streaming capabilities have made it cheaper and easier for filmmakers to take to the skies for a smooth, 4K aerial shot. We dive into the entry-level and enthusiast options from popular drone makers, like DJI, to see what each new drone brings to the market.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Reviews;